export const lineOptions = ["FLX10", "FLX20", "FLX30", "FLX35"] as const;

export type Line = (typeof lineOptions)[number];
